const SearchToggle = {
  data () {
    return {
      isActive: this.setActive
    }
  },
  props: [
    'setActive'
  ],
  watch: {
    setActive(newValue) {
      this.isActive = newValue
    }
  },
  methods: {
    handleClick () {
      bus.$emit('toggle_header_search')
    }
  }
}

export default SearchToggle
